module.exports = __webpack_public_path__ + "img/mac-icon7.fbf6e21.png";